import {TouchableOpacity, Image} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';

export interface MeatballMenuButtonProps {
  onPress(): void;
}

const MeatballMenuButton = (props: MeatballMenuButtonProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={props.onPress}
      style={styles.buttonStyle}>
      <Image
        resizeMode="contain"
        source={theme.images.meatballMenu}
        style={styles.imageStyle}
      />
    </TouchableOpacity>
  );
};

export default MeatballMenuButton;
